import { AxiosResponse } from "axios";
import { Utils } from "../../utils";
export const logInterResponse = (response: AxiosResponse) => {
  Utils.pushLog({
    tags: ["HTTP", "RESPONSE"],
    message: response.request.responseURL,
    extraArgs: [{ responseData: response.data, responseHeaders: response.headers }],
    timeStamp: Date.now(),
  });
  return response;
};
